<template>
  <div class="columns">
    <div class="column">
      <p class="subtitle">
        {{ $t("info") }}
      </p>
      <tr>
        <td>
          <b-field :label="$t('email')" />
        </td>
        <td>
          <b-input v-model="props.row.email" />
        </td>
      </tr>
      <tr>
        <td><b-field :label="$t('telephoneNumber')" /></td>
        <td>
          <PhoneNumberPicker v-model="props.row.telephoneNumber" :required="props.row.mobileNumber ? false : true" />
        </td>
      </tr>
      <tr>
        <td><b-field :label="$t('mobileNumber')" /></td>
        <td>
          <PhoneNumberPicker v-model="props.row.mobileNumber" :required="props.row.telephoneNumber ? false : true" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalStreetName')" />
        </td>
        <td>
          <b-input v-model="props.row.legalStreetName" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalCity')" />
        </td>
        <td>
          <b-input v-model="props.row.legalCity" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalZipCode')" />
        </td>
        <td>
          <b-input v-model="props.row.legalZipCode" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalCountry')" />
        </td>
        <td>
          <CountryPicker v-model="props.row.legalCountry" :is-loading="isLoading" :title="false" />
        </td>
      </tr>
      <b-button class="is-info mt-4 mb-4 mr-4" :loading="isLoading" @click="confirmChanges">
        {{ $t("saveChanges") }}
      </b-button>
      <b-field>
        <LastLoginInformation :uid="props.row.id" />
      </b-field>
    </div>

    <div class="column">
      <p class="subtitle">
        {{ $t("specialFields") }}
      </p>
      <span v-if="props.row.departments.length == 0">-</span>
      <b-taglist>
        <b-tag v-for="(department, key) in props.row.departments" :key="key" type="is-primary" size="is-medium">
          {{ $t(department) }}
        </b-tag>
      </b-taglist>
      <p class="subtitle mt-4">
        {{ $t("assocMembershipNotEditable") }}
      </p>
      <span v-if="props.row.associations.length == 0">-</span>
      <b-taglist class="mb-4">
        <b-tag v-for="(a, key) in props.row.associations" :key="key" type="is-primary" size="is-medium">
          {{ a }}
        </b-tag>
      </b-taglist>
      <p class="subtitle">
        {{ $t("languages") }}
      </p>
      <span v-if="props.row.langComb.length == 0">-</span>
      <div v-for="lang in props.row.langComb" :key="lang._sortId" class="box">
        <b-field grouped group-multiline>
          <LanguagePicker
            v-model="lang.lang1"
            class="control min-width-300"
            :blacklist="[lang.lang2]"
            :change-local="false"
            :loading="false"
            :disabled="true"
          />
          <b-tooltip type="control is-primary" :label="$t(lang.mono ? 'monodirectional' : 'bidirectional')">
            <b-button :icon-left="lang.mono ? 'arrow-right-bold' : 'arrow-left-right-bold'" />
          </b-tooltip>
          <LanguagePicker
            v-model="lang.lang2"
            class="control min-width-300"
            :blacklist="[lang.lang1]"
            :change-local="false"
            :loading="false"
            :disabled="true"
          />
        </b-field>
        <div class="ml-4 mt-2">
          <b-field>
            <b-checkbox class="ml-4 has-text-black" :value="lang.consecutive" :disabled="true">
              {{ $t("consecutive") }}
            </b-checkbox>
          </b-field>
          <b-field>
            <b-checkbox class="ml-4 has-text-black" :value="lang.simultaneous" :disabled="true">
              {{ $t("simultaneous") }}
            </b-checkbox>
          </b-field>
        </div>
      </div>
      <div v-if="props.row.approved == false">
        <p v-if="applications.length > 0" class="subtitle mt-4">
          {{ $t("openTranslatorApplications") }}
        </p>
        <div v-for="(a, i) in applications" :key="i">
          <b-field :label="$t('applicationText')">
            <b-input v-model="a.applicationText" maxlength="4000" type="textarea" :disabled="true" />
          </b-field>
          <div v-for="(f, k) in a.applicationFiles" :key="k" class="mb-3">
            <a :href="f.url" target="_blank">
              <b-button type="is-primary is-light">
                {{ f.name }}
              </b-button>
            </a>
          </div>
          <b-button class="mt-2" type="is-success" @click="$emit('manual-approval')">
            {{ $t("manualApprovalExplained") }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
import LanguagePicker from "@/components/LanguagePicker";
import CountryPicker from "@/components/CountryPicker";
import PhoneNumberPicker from "@/components/PhoneNumberPicker";
import LastLoginInformation from "@/components/LastLoginInformation";

export default {
  name: "DetailTranslatorsRow",
  components: {
    LanguagePicker,
    CountryPicker,
    PhoneNumberPicker,
    LastLoginInformation,
  },
  props: {
    props: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      admins: [],
      isLoading: false,
      modalActive: false,
      parentId: "",
      applications: [],
    };
  },
  methods: {
    confirmChanges() {
      this.$buefy.dialog.confirm({
        title: this.$t("saveChanges"),
        message: this.$t("changeInfoInfo"),
        confirmText: this.$t("saveChanges"),
        cancelText: this.$t("cancel"),
        type: "is-info",
        closeOnConfirm: true,
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          await this.saveChanges();
          this.isLoading = false;
          this.$parent.closeDetailRow();
        },
      });
    },
    /**
     * @todo change to save translator info
     */
    async saveChanges() {
      // this is personal data that gets saved with the user account
      let personalData = {
        email: this.props.row.email,
        telephoneNumber: this.props.row.telephoneNumber,
        mobileNumber: this.props.row.mobileNumber,
      };
      functions.httpsCallable("SetUserInformation")({ personalData });
      let data = {
        legalStreetName: this.props.row.legalStreetName,
        legalCity: this.props.row.legalCity,
        legalCountry: this.props.row.legalCountry,
        legalZipCode: this.props.row.legalZipCode,
      };
      // this data is unique to translator
      db.collection("member_translators")
        .doc(this.props.row.id)
        .set(data, { merge: true })
        .then(() => {
          this.$buefy.toast.open({
            message: this.$t("settingsSaved"),
            type: "is-success",
          });
        })
        .catch((err) => {
          this.$buefy.toast.open({
            message: err,
            type: "is-danger",
          });
        });
    },
  },
  firestore() {
    return {
      applications: db.collection("member_translators").doc(this.props.row.id).collection("applications"),
    };
  },
};
</script>
